/*
  aw-product.js — the version cards on the remix pack product page, 28 Sep.
  Markup: snippets/aw-version-picker.liquid, in sections/aw-band-product.liquid.

  Choosing a card copies its variant id into the product form's id input,
  which Dawn's product-form.js posts and Shopify's checkout button reads, the
  same hand-off Dawn's own picker makes. It also updates the price line, the
  add button (a sold-out version disables it) and the ?variant= in the address,
  so a shared link opens on the chosen version.
*/
(() => {
  if (window.awProductReady) return;
  window.awProductReady = true;

  const bind = (root) => {
    root.querySelectorAll('[data-aw-versions]').forEach((group) => {
      if (group.dataset.awBound) return;
      group.dataset.awBound = 'true';

      const formId = group.dataset.formId;
      const form = document.getElementById(formId);
      if (!form) return;
      const idInput = form.querySelector('input[name="id"]');
      const submit = form.querySelector('[type="submit"]');
      const submitLabel = submit ? submit.querySelector('span') : null;
      const payment = form.querySelector('.shopify-payment-button');
      const price = document.querySelector(`[data-aw-price-for="${formId}"]`);

      group.addEventListener('change', (event) => {
        const input = event.target;
        if (!(input instanceof HTMLInputElement) || !idInput) return;
        const available = input.dataset.available === 'true';

        idInput.value = input.value;
        idInput.disabled = !available;
        if (submit) {
          submit.disabled = !available;
          if (submitLabel) {
            submitLabel.textContent = available ? group.dataset.addLabel : group.dataset.soldOutLabel;
          }
        }
        if (payment) payment.hidden = !available;
        if (price && input.dataset.price) price.textContent = input.dataset.price;

        const url = new URL(window.location.href);
        url.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', url.toString());
      });
    });
  };

  bind(document);
  document.addEventListener('shopify:section:load', (event) => bind(event.target));
})();
